import React, { useEffect, useState } from "react";
import MainTitle from "components/MainTitle";
import Button from "components/Button";
import styled from "styled-components";
import InputControl from "components/InputControl";
import InputCpf from "components/InputCpf";
import { cpf } from "cpf-cnpj-validator";
import Analytics from "core/Utils/Analytics";

export const Strong = styled.p`
  font-weight: bold;
`;
export const ActionButtons = styled.div`
  button {
    margin-right: 14px;
  }
`;
const DependenteCpfPage = ({ setForm, formData, navigation, ...props }) => {
  const { go } = navigation;
  const [inputCpf, setInputCpf] = useState("");
  const [inputCpfValid, setInputCpfValid] = useState(false);
  const [error, setError] = useState("");
  let sanitizedCpf = inputCpf.replace(/[^\d]/g, "");

  useEffect(function () {
    Analytics().setVirtualPageView(`/meuperfil/meus-numeros/informar-cpf`);
  }, []);

  function confirmInvite() {
    props.setCustomData({
      ...props.customData,
      cpf: sanitizedCpf,
    });
    go("confirm");
  }

  function validateCpf(value) {
    setInputCpf(value);
    value = value.replace(/[^\d]/gi, "");
    if (value.length < 11) {
      setInputCpfValid(false);
    } else if (!cpf.isValid(value)) {
      setInputCpfValid(false);
      setError("CPF Inválido");
    } else {
      setInputCpfValid(true);
      setError("");
    }
  }

  return (
    <>
      <div className="mdn-Col-md-6">
        <MainTitle sm>Gerenciar meus números</MainTitle>
        <InputControl>
          <p className="mdn-Text mdn-Text--body mdn-u-marginTop--xxs">
            Digite no campo abaixo o CPF da pessoa que você deseja enviar o
            convite para se tornar dependente da linha selecionada
          </p>
        </InputControl>
        <InputControl>
          <InputCpf
            name="cpf"
            id="cpf"
            label="CPF do dependente"
            error={error}
            onlyNumbers={true}
            onChange={(e) => validateCpf(e.target.value)}
          />
        </InputControl>
        <ActionButtons>
          <Button secondary onClick={() => go("listNumbers")}>
            Voltar
          </Button>
          <Button disabled={!inputCpfValid} onClick={confirmInvite}>
            Avançar
          </Button>
        </ActionButtons>
      </div>
    </>
  );
};

export default DependenteCpfPage;
